import React from 'react';
import styles from './offscreen.scss';

type Props = {
  children: React.ReactNode
}
export default function Offscreen({ children }: Props) {

  return (
    <div className={styles.offscreen}>
      {children}
    </div>
  );
}
